/**
 * Parses the response from a login endpoint.
 * Common across different login request types.
 *
 * @param {Object} json - Raw API response JSON
 * @returns {Object} Parsed login response
 */
export const parseLoginResponse = (json) => {
  if (!json) return {};

  return {
    jwt: json.jwt || "",
    token: json.token || "",
    secret: json.secret || "",
    renewableSecret: json.renewableSecret ?? false,
    loggingToken: json.loggingToken || "",
  };
};

export default { parseLoginResponse };
